(function () {
    'use strict';

    angular.module('elogbooks.admin.asset-score-types', []);
})();
